import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";
import config from "config/config";

export let ErrorBoundary = React.Fragment;
if (config[process.env.REACT_APP_ENV?.toUpperCase()]?.BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: config[process.env.REACT_APP_ENV?.toUpperCase()]?.BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: ["development", "staging", "pre-production", "production"],
    releaseStage: config[process.env.REACT_APP_ENV?.toUpperCase()]?.BUGSNAG_RELEASE_STAGE,
  });
  ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
}
